import { Injectable, inject } from '@angular/core';
import { LoginServiceSchueco } from './login-service-schueco.service';
import { LoginServiceJwt } from './login-service-jwt.service';
import { CLIENT_DATA } from '@frontend/util-api-data';

export function loginFactory(loginServiceSchueco: LoginServiceSchueco, loginServiceJwt: LoginServiceJwt): LoginService {
  const clientData = inject(CLIENT_DATA);
  switch (clientData.name) {
    case 'jansen':
    case 'aks':
      return loginServiceJwt;
    default:
      return loginServiceSchueco;
  }
}

@Injectable({
  providedIn: 'root',
  useFactory: loginFactory,
})
export abstract class LoginService {
  abstract login(username?: string, password?: string): Promise<boolean>;
  abstract logout(): void;
  abstract isLoggedIn(): Promise<boolean>;
  abstract getUserInfo(): any;
}
